import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import { ApiUrlConstants } from "../../common/constants/api.constants";
import { AccountDetails } from "../interface/account-details";
import { DistributorDetails } from "../interface/distributor-details";
import { OrderHistoryDetails } from "../interface/order-history-details";

@Injectable()
export class UplineReportService {

    private observable: Observable<any>;

    constructor(private _http: Http) {

    }

    getUplineDetails(distributorId: string, homeCountry: string, pageNumber?: number, pageSize?: number, sort?: String, sortColumn?: string[], searchTerm?: string,homeCountryCode?:string):Observable<DistributorDetails[]>{
 
        let _url = ApiUrlConstants.reportApiUrl;
        let url: string = _url + "/distributors/" + distributorId + "/country/" + homeCountry + "/upline?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&sort=" + sort + "&elements=" + sortColumn + "&searchTerm=" + searchTerm;
        
        if (homeCountryCode) {
            url = url+ "&homeCountryCode=" + homeCountryCode
        }
        this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());

        return this.observable;
    }

    getAccountDetails(distributorId: string, homeCountry: string):Observable<AccountDetails>{
        let url: string = ApiUrlConstants.reportApiUrl + "/distributors/" + distributorId + "/country/" + homeCountry + "/upline-account-details";

        this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());

        return this.observable;
    }

    getOrderHistoryDetails(distributorId: string, homeCountry: string):Observable<OrderHistoryDetails[]>{
        let url: string = ApiUrlConstants.reportApiUrl + "/distributors/" + distributorId + "/country/" + homeCountry + "/upline-order-details";

        this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());

        return this.observable;
    }

    getRecentOrderHistoryDetails(distributorId: string, homeCountry: string, pageNumber?: number, pageSize?: number, sort?: String, sortColumn?: string[]):Observable<OrderHistoryDetails[]>{
        let _url = ApiUrlConstants.reportApiUrl;
        let url: string = _url + "/distributors/" + distributorId + "/country/" + homeCountry + "/upline-order-details?pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&sort=" + sort + "&elements=" + sortColumn;
        
        this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());

        return this.observable;
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/services/upline-report.service.ts